import React from 'react';
import SafeIcon from '../common/SafeIcon';
import Avatar from './common/Avatar';
import { FiSearch, FiBell } from 'react-icons/fi';

const Header = () => {
  return (
    <header className="h-20 bg-[#0a0a0f]/80 backdrop-blur-md border-b border-white/5 flex items-center justify-between px-8 sticky top-0 z-10">
      <div className="flex-1 max-w-xl">
        <div className="relative group">
          <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-violet-400 transition-colors" />
          <input
            type="text"
            placeholder="Search accounts, health metrics, playbooks..."
            className="w-full bg-[#13131a] border border-white/5 rounded-full py-2.5 pl-12 pr-4 text-sm text-slate-200 focus:outline-none focus:border-violet-500/50 focus:ring-1 focus:ring-violet-500/50 transition-all placeholder:text-slate-600"
          />
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="hidden lg:flex flex-col items-end">
          <span className="text-[10px] text-slate-500 uppercase tracking-widest font-bold">Network Health</span>
          <span className="text-emerald-400 font-bold text-lg leading-none mt-1">84.2</span>
        </div>
        
        <div className="h-8 w-px bg-white/10 hidden sm:block"></div>

        <button className="relative text-slate-400 hover:text-white transition-colors p-2">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-rose-500 rounded-full border border-[#0a0a0f]"></span>
        </button>
        
        <Avatar name="Churn Admin" size="md" className="hover:scale-105 transition-transform cursor-pointer" />
      </div>
    </header>
  );
};

export default Header;